import * as types from '../ActionTypes/ActivityActionTypes';

export class ActivityActionCreators {
    // get profile activity
    static getProfileActivityRequest = (userId, completionCallback) => ({
        type: types.GET_PROFILE_ACTIVITY_REQUEST,
        meta: { userId, completionCallback },
    });

    static getProfileActivitySuccess = (activity, offsetId, offsetDate) => ({
        type: types.GET_PROFILE_ACTIVITY_SUCCESS,
        payload: { activity, offsetId, offsetDate },
    });

    static getProfileActivityFailed = payload => ({
        type: types.GET_PROFILE_ACTIVITY_FAILED,
        payload,
    });

    // load more activity
    static loadMoreActivityRequest = (userId, offsetId, offsetDate) => ({
        type: types.LOAD_MORE_ACTIVITY_REQUEST,
        meta: { userId, offsetId, offsetDate },
    });

    static loadMoreActivitySuccess = (activity, offsetId, offsetDate) => ({
        type: types.LOAD_MORE_ACTIVITY_SUCCESS,
        payload: { activity, offsetId, offsetDate },
    });

    static loadMoreActivityFailed = payload => ({
        type: types.LOAD_MORE_ACTIVITY_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/ActivityActionCreators.js